var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [_vm.bemBlock, "product-detail", "product-detail-vue"],
      attrs: { "data-context": _vm.context }
    },
    [
      _c("BaseProductDataForSfra", { attrs: { product: _vm.product } }),
      _vm._v(" "),
      _c(
        "button",
        {
          class: _vm.bemElement("button", {
            selected: _vm.selected,
            disabled: _vm.disabled
          }),
          attrs: { "data-url": _vm.size.url },
          on: {
            click: function($event) {
              !_vm.selected && _vm.selectSize()
            }
          }
        },
        [
          _c("span", { staticClass: "visually-hidden" }, [
            _vm._v(_vm._s(_vm.product.productName))
          ]),
          _vm._v(" "),
          !!_vm.swatchImage
            ? _c("img", {
                class: [
                  _vm.bemElement("swatch-img"),
                  {
                    loading: _vm.loadingImage
                  }
                ],
                attrs: { alt: _vm.swatchImage.alt, src: _vm.swatchImage.url },
                on: {
                  error: _vm.handleImageError,
                  load: function($event) {
                    _vm.loadingImage = false
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.disabled
            ? _c("span", {
                class: _vm.bemElement("disabled-icon", {
                  light: _vm.isDarkColor
                })
              })
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }